import { render, staticRenderFns } from "./whoisSearch.vue?vue&type=template&id=1d75dc20&scoped=true&"
import script from "./whoisSearch.vue?vue&type=script&lang=js&"
export * from "./whoisSearch.vue?vue&type=script&lang=js&"
import style0 from "./whoisSearch.vue?vue&type=style&index=0&id=1d75dc20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75dc20",
  null
  
)

export default component.exports